import HTTP from "../utils/HTTP";

class SendEmailService {
  fetchEmails = () => {
    return HTTP.get("/admin/email");
  };
  addEmail = (data) => {
    return HTTP.post("/admin/email/add", data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  };
  deleteEmail = (id) => {
    return HTTP.delete(`/admin/email/delete/${id}`);
  };
}

export default new SendEmailService();
